<template>
  <div class="main">
    <van-nav-bar title="我的房屋" left-arrow @click-left="onClickLeft" />
    <div class="container">
      <div class="item" v-for="(item, index) in dataList" :key="index" @click="getInfo(item, index)">
        <div class="content">
          <div class="content-top">
            <span class="title">{{ item.wyqymc }}</span>
            <span v-if="index == 0" class="log">默认</span>
          </div>

          <div style="margin-top: 16px;min-height: 20px;padding-right:15px">
            <img class="location" src="../../assets/img/icon_location.png" alt="" />&nbsp;<span class="address">{{
              item.fwdz
            }}</span>
          </div>
        </div>
        <div class="footer">
          <div class="left">
            <div class="circle " :class="{ active: active == index }"></div>
            <span class="money">默认房屋</span>
          </div>
          <div class="right">
            <span class="hoster"> 业主：</span><span>{{ item.yzmc }}</span>
          </div>
        </div>
      </div>
    </div>
    <div ref="save" class="save">
      <van-tabbar>
        <van-button :loading="sumitLoad" @click="handlerSave" class="save-btn">确认更改</van-button>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import api from '@/api/login.js'
import login from '@/api/login.js'

export default {
  name: '',
  components: {

  },
  data() {
    return {
      dataList: [],
      active: 0,
      mrfwId: '',
      currentWyqy: '',
      userinfo: null,
      currentwyqyId: null,
      currentwyqydm: null,
      sumitLoad: false
    }
  },
  created() {

  },
  mounted() {
    let windowHeight = document.documentElement.clientHeight
    this.userinfo = JSON.parse(sessionStorage.getItem('userinfo'))
    this.dataList = this.userinfo.yzfwVo
    this.mrfwId = this.dataList[0].fwId
    this.currentWyqy = this.dataList[0].fwmc
    this.currentwyqyId = this.dataList[0].wyqyId
    this.currentwyqydm = this.dataList[0].wyqydm
    this.$refs.save.style.top = windowHeight + 'px'
    // this.getIphone()
  },
  methods: {
    getIphone() {
      let iPhonex_xs = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812
      let iPhonexsmax = window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896
      let iPhonexr = window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896
      let isIPhone12 =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 390 &&
        window.screen.height === 844;
      let isIPhone12ProMax =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 428 &&
        window.screen.height === 926;

      let isIPhone12mini =
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 360 &&
        window.screen.height === 780;

      if (iPhonex_xs || iPhonexsmax || iPhonexr || isIPhone12ProMax || isIPhone12 || isIPhone12mini) {

      }

    },
    onClickLeft() {
      location.href = '/usercenter'
    },
    getInfo(item, idx) {
      console.log('更改房屋', item)
      this.currentWyqy = item.fwmc
      this.currentwyqyId = item.wyqyId
      this.currentwyqydm = item.wyqydm
      this.mrfwId = item.fwId
      this.active = idx
      this.dataList.forEach((item, index) => {
        if (idx == index) {
          item.check = 1
        } else {
          item.check = 0
        }
      })
    },
    handlerSave() {

      let params = {
        mrfw: this.mrfwId,
        openId: this.userinfo.openId,
        id: this.userinfo.id
      }
      if (this.mrfwId) {
        this.sumitLoad = true
        api.update(params).then(res => {
          this.sumitLoad = false
          if (res.data.code == 200) {
            this.$toast.success({
              message: '更新成功',
            })

            sessionStorage.setItem('currentWyqy', this.currentWyqy)
            sessionStorage.setItem('wyqy', this.currentwyqyId)
            sessionStorage.setItem('wyqydm', this.currentwyqydm)


            this.getUserinfo()

          } else {

            this.$toast.fail({
              message: '更新失败',
            })
          }
        }).catch(err => {
          this.sumitLoad = false
          this.$toast.fail({
            message: '更新失败',
          })

        })
      } else {
        return this.$toast.fail({
          message: '暂无房屋可以操作',
        })
      }

    },
    getUserinfo() {
      let openId = sessionStorage.getItem('openId')
      login.info({ openId: openId }).then(res => {
        if (res.data.code == 200) {
          let obj = JSON.stringify(res.data.data);
          sessionStorage.setItem('userinfo', obj)
          if (res.data.data.yzfwVo.length) {
            sessionStorage.setItem('fwId', res.data.data.yzfwVo[0].fwId)

          }

        } else {
          this.$toast.fail({
            message: '获取信息失败',
          })
        }
      }).catch(err => {
        this.$toast.fail({
          message: err,
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.van-nav-bar {
  position: sticky;
  top: 0;
}

.main {
  position: relative;
  min-height: 100vh;
  background-color: #f4f7f9;
}

.container {
  padding-bottom: 2px;
  margin: 20px;
  //   height: 100%;

  .item {
    min-height: 134px;
    margin-bottom: 20px;

    .content {
      position: relative;
      width: 100%;
      min-height: 98px;
      padding: 20px 0 16px 16px;
      background: #ffffff;

      .content-top {
        display: flex;
        align-items: center;

        .title {
          min-width: 87px;
          height: 22px;
          font-size: 16px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #222120;
          line-height: 19px;
          margin: 0;
        }

        .log {
          margin-left: 20px;
          width: 36px;
          height: 23px;
          font-size: 12px;
          font-weight: 500;
          color: #ff6c1a;
          text-align: center;
          line-height: 23px;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          border: 1px solid #ff6c1a;
        }
      }

      .location {
        width: 20px;
        height: 20px;
        vertical-align: middle;
      }

      .address {
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 16px;
        vertical-align: middle;
      }

      .footer {
        height: 30px;
        width: 100%;
      }
    }

    .footer {
      display: flex;
      align-items: center;
      width: 100%;
      height: 36px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;
      border-top: 1px solid rgb(217, 217, 217);
      opacity: 1;

      .left {
        flex: 60%;
        align-items: center;
        display: flex;
        height: 17px;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #222120;
        line-height: 14px;
        padding-left: 16px;
        line-height: 17px;

        .circle {
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url(../../assets/img/icon_radio_false.png) no-repeat;
          //   border: 1px solid #4e4d4d;
          margin-right: 10px;
        }

        .active {
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          border-radius: 10px;
          border: 1px solid #ff6c1a;
          background: url(../../assets/img/icon_radio_true.png) no-repeat;
          background-position: -1px 0;
        }

        .money {
          font-weight: 700;
        }
      }

      .right {
        flex: 40%;
        height: 20px;
        font-size: 12px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 14px;

        .hoster {
          font-weight: 700;
        }
      }
    }
  }
}

.save {
  position: sticky;
  top: 90vh;
  width: 100%;
  height: 66px;
  padding: 10px 20px;
  // background-color: #fff;

  .save-btn {
    width: 100%;
    height: 46px;
    background: #ff6c1a;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
    border-radius: 23px 23px 23px 23px;
    margin-top: 10px;
  }
}

.van-tabbar--fixed {
  height: 66px;
}
</style>
